import { useEffect, useState } from 'react';
import './css/Escola.css';
import axios from 'axios';
import Layout from './components/Layout';
import { API_BASE_URL } from '../config/ApiConfig';
const DRIVE_PATH_URL = API_BASE_URL.DRIVE_PATH;
import { Link, useNavigate } from 'react-router-dom';
import TableContainer from './components/TableContainer';
import DataTable from './components/DataTable';
import PaginationBar from './components/PaginationBar';
import useDefaultModal from './components/hooks/useDefaultModal';
import useConfirmModal from './components/hooks/useConfirmModal';
import ConfirmModal from './components/modals/ConfirmModal';
import DefaultModal from './components/modals/DefaultModal';
import DrivePathModal from './components/modals/DrivePathModal';
import EscolaModal from './components/modals/EscolaModal';
import { unformatCNPJ, formatCNPJ, isValidCNPJ } from './utils/cnpjUtils';
import ResponsiveShadow from './components/ResponsiveShadow';
import usePagination10 from './components/hooks/usePagination10';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import Toolbar from './components/Toolbar';
import LoadingModal from './components/modals/LoadingModal';

// Certifique-se de que o CSS para .full-screen-div ainda está sendo importado
// .full-screen-div { display: flex; flex-direction: column; min-height: 100vh; }

function Escolas() {
  // ... todo o seu state, useEffects e funções (NÃO MUDA NADA AQUI) ...
  const [Escolas, setEscolas] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [atualizar, setAtualizar] = useState([]);
  const [escolaSelecionada, setEscolaSelecionada] = useState(null);
  const token = localStorage.getItem('token');
  const isMaster = JSON.parse(localStorage.getItem('user') || '{}')?.role === 'MASTER';
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isMaster) {
      navigate('/home');
    }
  }, [isMaster, navigate]);
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const [showDrivePathModal, setShowDrivePathModal] = useState(false);
  const [drivePathValue, setDrivePathValue] = useState('');
  const [savingDrivePath, setSavingDrivePath] = useState(false);
  function handleAddDrivePath() {
    if (!escolaSelecionada) return;
    setShowDrivePathModal(true);
    setDrivePathValue('');
    // Buscar drive_path existente
    axios.get(`${DRIVE_PATH_URL}/${escolaSelecionada.cnpj}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => {
        if (res.data && res.data.path) {
          setDrivePathValue(res.data.path);
        }
      })
      .catch(() => {
        setDrivePathValue('');
      });
  }

  function handleSaveDrivePath() {
    if (!escolaSelecionada || !drivePathValue) return;
    setSavingDrivePath(true);
    axios.post(DRIVE_PATH_URL, {
      cnpj: escolaSelecionada.cnpj,
      path: drivePathValue
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(() => {
        setShowDrivePathModal(false);
        showDefaultModal('success', 'Drive Path adicionado com sucesso!');
      })
      .catch(() => {
        showDefaultModal('error', 'Erro ao adicionar Drive Path!');
      })
      .finally(() => setSavingDrivePath(false));
  }
  const { setConfirmModal, showConfirmModal } = useConfirmModal();

  // Escola modal state
  const [showEscolaModal, setShowEscolaModal] = useState(false);
  const [escolaForm, setEscolaForm] = useState({
    cnpj: '', inep: '', nome: '', conselho: '', endereco: '', email: '', telefone: '', celular: '', logrNome: '', logrNum: '', logrCompl: '', logrBairro: '', logrCep: '', logrCidade: '', logrUf: ''
  });
  const [ufs, setUfs] = useState([]);
  const [cidades, setCidades] = useState([]);
  const [isBuscandoCnpj, setIsBuscandoCnpj] = useState(false);

  useEffect(() => {
    // load UFs once
    const token = localStorage.getItem('token');
    axios.get(`${API_BASE_URL.UF}/all`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setUfs(res.data || []))
      .catch(() => setUfs([]));
  }, []);

  useEffect(() => {
    if (!escolaForm.logrUf) {
      setCidades([]);
      return;
    }
    const token = localStorage.getItem('token');
    axios.get(`${API_BASE_URL.MUNICIPIO}/uf/${escolaForm.logrUf}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setCidades(res.data || []))
      .catch(() => setCidades([]));
  }, [escolaForm.logrUf]);

  function handleEscolaChange(e) {
    const { name, value } = e.target;
    setEscolaForm(prev => ({ ...prev, [name]: value }));
  }

  function stripMask(value) { return value ? value.replace(/\D/g, '') : ''; }

  async function handleBuscarCnpj() {
    const cnpjNum = stripMask(escolaForm.cnpj);
    if (cnpjNum.length !== 14) { showDefaultModal('error', 'Digite um CNPJ válido antes de buscar.'); return; }
    setIsBuscandoCnpj(true);
    try {
      const token = localStorage.getItem('token');
      const r = await axios.get(`${API_BASE_URL.CNPJ_PROXY}/${cnpjNum}`, { headers: { Authorization: `Bearer ${token}` } });
      const d = r.data;
      if (d.status === 'ERROR') { showDefaultModal('error', d.message || 'CNPJ não encontrado.'); return; }
      setEscolaForm(f => ({
        ...f,
        nome: d.nome || f.nome,
        email: d.email || f.email,
        telefone: d.telefone || f.telefone,
        logrNome: d.logradouro || f.logrNome,
        logrNum: d.numero || f.logrNum,
        logrCompl: d.complemento || f.logrCompl,
        logrBairro: d.bairro || f.logrBairro,
        logrCep: (d.cep || '').replace(/\D/g, '') || f.logrCep,
        logrUf: d.uf || f.logrUf,
        logrCidade: d.municipio || f.logrCidade,
      }));
    } catch (err) {
      const status = err?.response?.status;
      if (status === 429) {
        showDefaultModal('error', 'Limite de consultas atingido. Aguarde 1 minuto e tente novamente.');
      } else if (status === 400) {
        showDefaultModal('error', 'CNPJ inválido.');
      } else {
        showDefaultModal('error', `Erro ao consultar CNPJ${status ? ` (${status})` : ''}. Tente novamente em instantes.`);
      }
    } finally {
      setIsBuscandoCnpj(false);
    }
  }

  function handleOpenNewEscola() {
    setEscolaForm({ cnpj: '', inep: '', nome: '', conselho: '', endereco: '', email: '', telefone: '', celular: '', logrNome: '', logrNum: '', logrCompl: '', logrBairro: '', logrCep: '', logrCidade: '', logrUf: '' });
    setShowEscolaModal(true);
  }

  function handleOpenEditEscola() {
    if (!escolaSelecionada) return;
    const token = localStorage.getItem('token');
    // tentar buscar detalhes completos pelo backend; se falhar, usa o objeto já disponível
    axios.get(`${API_BASE_URL.ESCOLA}/${escolaSelecionada.cnpj}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        const s = res.data || {};
        const formObj = {
          cnpj: s.cnpj || escolaSelecionada.cnpj || '',
          inep: s.inep || s.INEP || escolaSelecionada.inep || escolaSelecionada.INEP || '',
          nome: s.nome || s.NOME || escolaSelecionada.nome || escolaSelecionada.NOME || '',
          conselho: s.conselho || s.CONSELHO || escolaSelecionada.conselho || escolaSelecionada.CONSELHO || '',
          endereco: s.endereco || s.ENDERECO || s.logrNome || escolaSelecionada.endereco || escolaSelecionada.ENDERECO || escolaSelecionada.logrNome || '',
          email: s.email || escolaSelecionada.email || '',
          telefone: s.telefone || escolaSelecionada.telefone || '',
          celular: s.celular || escolaSelecionada.celular || escolaSelecionada.fax || '',
          logrNome: s.logrNome || s.logradouro || escolaSelecionada.logrNome || escolaSelecionada.logradouro || '',
          logrNum: s.logrNum || s.numero || escolaSelecionada.logrNum || escolaSelecionada.numero || '',
          logrCompl: s.logrCompl || s.complemento || escolaSelecionada.logrCompl || escolaSelecionada.complemento || '',
          logrBairro: s.logrBairro || s.bairro || escolaSelecionada.logrBairro || escolaSelecionada.bairro || '',
          logrCep: s.logrCep || (s.cep ? String(s.cep).replace(/\D/g, '') : '') || (escolaSelecionada.logrCep || (escolaSelecionada.cep ? String(escolaSelecionada.cep).replace(/\D/g, '') : '')),
          logrUf: s.logrUf || s.uf || s.UF || escolaSelecionada.logrUf || escolaSelecionada.uf || escolaSelecionada.UF || '',
          logrCidade: s.logrCidade || s.municipio || s.cidade || s.MUNICIPIO || escolaSelecionada.logrCidade || escolaSelecionada.municipio || escolaSelecionada.cidade || escolaSelecionada.MUNICIPIO || ''
        };
        setEscolaForm(formObj);
        const ufToLoad = formObj.logrUf;
        if (ufToLoad) {
          axios.get(`${API_BASE_URL.MUNICIPIO}/uf/${ufToLoad}`, { headers: { Authorization: `Bearer ${token}` } })
            .then(r => setCidades(r.data || []))
            .catch(() => setCidades([]))
            .finally(() => setShowEscolaModal(true));
        } else {
          setShowEscolaModal(true);
        }
      })
      .catch(() => {
        // fallback leve: usa o objeto já presente
        const formObj = {
          cnpj: escolaSelecionada.cnpj || '',
          inep: escolaSelecionada.inep || escolaSelecionada.INEP || '',
          nome: escolaSelecionada.nome || escolaSelecionada.NOME || '',
          conselho: escolaSelecionada.conselho || escolaSelecionada.CONSELHO || '',
          endereco: escolaSelecionada.endereco || escolaSelecionada.ENDERECO || escolaSelecionada.logrNome || '',
          email: escolaSelecionada.email || '',
          telefone: escolaSelecionada.telefone || '',
          celular: escolaSelecionada.celular || escolaSelecionada.fax || '',
          logrNome: escolaSelecionada.logrNome || escolaSelecionada.logradouro || '',
          logrNum: escolaSelecionada.logrNum || escolaSelecionada.numero || '',
          logrCompl: escolaSelecionada.logrCompl || escolaSelecionada.complemento || '',
          logrBairro: escolaSelecionada.logrBairro || escolaSelecionada.bairro || '',
          logrCep: escolaSelecionada.logrCep || (escolaSelecionada.cep ? String(escolaSelecionada.cep).replace(/\D/g, '') : ''),
          logrUf: escolaSelecionada.logrUf || escolaSelecionada.uf || escolaSelecionada.UF || '',
          logrCidade: escolaSelecionada.logrCidade || escolaSelecionada.municipio || escolaSelecionada.cidade || escolaSelecionada.MUNICIPIO || ''
        };
        setEscolaForm(formObj);
        const ufToLoad = formObj.logrUf;
        if (ufToLoad) {
          axios.get(`${API_BASE_URL.MUNICIPIO}/uf/${ufToLoad}`, { headers: { Authorization: `Bearer ${token}` } })
            .then(r => setCidades(r.data || []))
            .catch(() => setCidades([]))
            .finally(() => setShowEscolaModal(true));
        } else {
          setShowEscolaModal(true);
        }
      });
  }

  function handleEscolaSubmit(ev) {
    ev.preventDefault();
    const token = localStorage.getItem('token');
    const payload = { ...escolaForm, cnpj: unformatCNPJ(escolaForm.cnpj) };
    if (!isValidCNPJ(payload.cnpj)) {
      showDefaultModal('error', 'CNPJ inválido');
      return;
    }
    if (!payload.inep || String(payload.inep).trim() === '') {
      showDefaultModal('error', 'INEP é obrigatório');
      return;
    }
    if (!payload.nome || String(payload.nome).trim() === '') {
      showDefaultModal('error', 'Nome é obrigatório');
      return;
    }
    // limpar máscaras para envio
    const strip = v => v ? String(v).replace(/\D/g, '') : '';
    payload.telefone = strip(payload.telefone);
    payload.celular = strip(payload.celular || payload.fax || '');
    payload.logrCep = strip(payload.logrCep);
    // garantir campos esperados pela API / DB
    payload.municipio = payload.logrCidade || payload.municipio || '';
    payload.uf = payload.logrUf || payload.uf || '';
    // prioridade: campo direto endereco/conselho, senão construir a partir de componentes
    payload.endereco = payload.endereco || payload.logrNome || '';
    payload.conselho = payload.conselho || '';
    axios.post(`${API_BASE_URL.ESCOLA}/save`, payload, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => {
        setShowEscolaModal(false);
        setAtualizar(prev => !prev);
      })
      .catch(err => {
        showDefaultModal('error', err.response?.data?.message || err.message || 'Erro ao salvar escola');
      });
  }

  useEffect(() => {
    if (!token) {
      navigate('/');
    }
    setLoading(true);
    axios
      .get(`${API_BASE_URL.ESCOLA}/all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(result => {
        console.log('Dados recebidos:', result.data);
        setEscolas(result.data);
      })
      .catch(error => {
        console.error('Erro ao obter escolas:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [atualizar]);

  // Função para lidar com a exclusão
  function handleDelete(c) {
    showConfirmModal('delete', () => handleConfirmDelete(c));
  }

  function handleConfirmDelete(c) {
    axios
      .get(`${API_BASE_URL.VINCULO}/exists_cnpj/` + c.cnpj, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(result => {
        if (result.data.exists) {
          showDefaultModal(
            'error',
            'Esta Escola/Entidade possui vínculos e não pode ser excluído. Exclua os vínculos antes de tentar novamente.'
          );
        } else {
          axios
            .delete(`${API_BASE_URL.ESCOLA}/delete/` + c.cnpj, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
            .then(() => {
              setAtualizar(prev => !prev);
            });
        }
      })
      .catch(error => {
        console.error('Erro ao verificar vínculos:', error);
        const status = error?.response?.status;
        if (status === 401) {
          setTimeout(() => navigate('/'), 0);
        } else {
          showDefaultModal('error', error.response?.data?.message || error.message || 'Erro ao excluir o registro!');
        }
      });
  }

  // Função para filtrar os fabricantes com base na busca
  const normalizeString = str => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
  };

  const escolasFiltrados = Array.isArray(Escolas)
    ? Escolas.filter(c => {
        const normalizedBusca = normalizeString(filtro);
        return (
          normalizeString(c.nome).includes(normalizedBusca) ||
          normalizeString(c.cnpj).includes(normalizedBusca) ||
          normalizeString(c.municipio).includes(normalizedBusca)
        );
      })
    : [];

  // Paginação dos escolas filtrados
  const totalItems = escolasFiltrados.length;
  const { setPagination } = usePagination10(totalItems);
  const selectedEscolas = escolasFiltrados.slice(
    setPagination.startIndex,
    setPagination.startIndex + setPagination.rowsPerPage
  );

  return (
    <Layout>
      <LoadingModal show={isLoading} />
      <ResponsiveShadow>
        <PageHeader title="Escolas Cadastradas" icon="bi-buildings" />
        <PageContent style={{ paddingBottom: 0 }}>
          <Toolbar
            onNew={isMaster ? handleOpenNewEscola : undefined}
            onEdit={isMaster ? handleOpenEditEscola : undefined} disableEdit={!escolaSelecionada}
            onDelete={isMaster ? () => escolaSelecionada && handleDelete(escolaSelecionada) : undefined} disableDelete={!escolaSelecionada}
          >
              <button
                className="btn btn-outline-success btn-sm botao-igual"
                disabled={!escolaSelecionada}
                onClick={handleAddDrivePath}
                title="Adicionar Drive Path para esta escola"
              >
                <i className="bi bi-hdd-network me-1"></i>
                Documentos
              </button>
              <DrivePathModal
                show={showDrivePathModal}
                escola={escolaSelecionada}
                value={drivePathValue}
                onChange={e => setDrivePathValue(e.target.value)}
                onSave={handleSaveDrivePath}
                onClose={() => setShowDrivePathModal(false)}
                saving={savingDrivePath}
              />
              <button
                className="btn btn-outline-primary btn-sm botao-igual"
                disabled={!escolaSelecionada || !escolaSelecionada.inep}
                onClick={() => {
                  if (escolaSelecionada && escolaSelecionada.inep) {
                    const ano =
                      localStorage.getItem('ano') || new Date().getFullYear();
                    const fndeUrl = `https://www.fnde.gov.br/pddeinfo/pddeinfo/escola/consultar?ano=${ano}&co_escola=${escolaSelecionada.inep}&cnpj=&consultar=Consultar`;
                    window.open(fndeUrl, '_blank');
                  }
                }}
                title="Consultar no FNDE"
              >
                <i className="bi bi-box-arrow-up-right me-1"></i>
                PDDE REX
              </button>
              <button
                className="btn btn-outline-info btn-sm botao-igual centralizar-se-impar"
                disabled={!escolaSelecionada || !escolaSelecionada.cnpj}
                onClick={() => {
                  if (escolaSelecionada && escolaSelecionada.cnpj) {
                    const receitaUrl = `https://servicos.receita.fazenda.gov.br/Servicos/cnpjreva/Cnpjreva_Solicitacao.asp?cnpj=${escolaSelecionada.cnpj}`;
                    window.open(receitaUrl, '_blank');
                  }
                }}
                title="Consultar CNPJ na Receita Federal"
              >
                <i className="bi bi-building me-1"></i>
                CNPJ
              </button>

            <div className="input-group input-group-sm toolbar-search">
              <span className="input-group-text bg-light"><i className="bi bi-search"></i></span>
              <input
                type="text"
                className="form-control"
                placeholder="Buscar por CNPJ, Nome ou Cidade"
                value={filtro}
                onChange={e => setFiltro(e.target.value.toUpperCase())}
                style={{ textTransform: 'uppercase', fontVariant: 'normal' }}
              />
            </div>
          </Toolbar>

          <TableContainer isLoading={false}>
              <DataTable head={
                  <tr>
                    <th scope="col" className="px-2 d-none d-md-table-cell">CNPJ</th>
                    <th scope="col" className="px-2">Nome</th>
                    <th scope="col" className="px-2">INEP</th>
                    <th scope="col" className="px-2">Cidade</th>
                    <th scope="col" className="px-2">UF</th>
                  </tr>
                }>
              <tbody>
                {selectedEscolas.map(c => (
                    <tr
                      key={c.cnpj}
                      className={
                        escolaSelecionada && escolaSelecionada.cnpj === c.cnpj
                          ? 'table-primary'
                          : ''
                      }
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        if (
                          escolaSelecionada &&
                          escolaSelecionada.cnpj === c.cnpj
                        ) {
                          setEscolaSelecionada(null); // Desseleciona se já estiver selecionada
                        } else {
                          setEscolaSelecionada(c); // Seleciona a escola
                        }
                      }}
                    >
                      <td className="px-2 d-none d-md-table-cell">
                        {c.cnpj}
                      </td>
                      <td className="px-2">{c.nome}</td>
                      <td className="px-2">{c.inep || '-'}</td>
                      <td className="px-2">{c.municipio}</td>
                      <td className="px-2">{c.uf}</td>
                    </tr>
                  ))}
              </tbody>
            </DataTable>
          </TableContainer>
        </PageContent>

        <PaginationBar setPagination={setPagination} />
      </ResponsiveShadow>

      <ConfirmModal {...setConfirmModal} />
      <DefaultModal {...setDefaultModal} />
      <EscolaModal show={showEscolaModal} onClose={() => setShowEscolaModal(false)} onSubmit={handleEscolaSubmit} form={escolaForm} handleChange={handleEscolaChange} ufs={ufs} cidades={cidades} onBuscarCnpj={handleBuscarCnpj} isBuscandoCnpj={isBuscandoCnpj} />
    </Layout>
  );
}

export default Escolas;
